var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/nav-group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/nav-group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.249966,12.0000215 C14.249966,13.242206 13.2421559,14.2500161 11.9999714,14.2500161 C10.7577869,14.2500161 9.74997675,13.242206 9.74997675,12.0000215 C9.74997675,10.7578369 10.7577869,9.75002682 11.9999714,9.75002682 C13.2421559,9.75002682 14.249966,10.7578369 14.249966,12.0000215 Z M19.8749526,9.75002682 C21.1171372,9.75002682 22.1249472,10.7578369 22.1249472,12.0000215 C22.1249472,13.242206 21.1171372,14.2500161 19.8749526,14.2500161 C18.6327681,14.2500161 17.624958,13.242206 17.624958,12.0000215 C17.624958,10.7578369 18.6327681,9.75002682 19.8749526,9.75002682 Z M4.12499017,9.75002682 C5.3671747,9.75002682 6.3749848,10.7578369 6.3749848,12.0000215 C6.3749848,13.242206 5.3671747,14.2500161 4.12499017,14.2500161 C2.88280563,14.2500161 1.87499553,13.242206 1.87499553,12.0000215 C1.87499553,10.7578369 2.88280563,9.75002682 4.12499017,9.75002682 Z",
    id: "icon-elipsis",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavGroup);
export default __webpack_public_path__ + "static/media/nav-group.cfac4031.svg";
export { ForwardRef as ReactComponent };